<template>
  <v-col
    cols="12"
    class="header px-0 pb-1 pt-4"
    :style="headerStyle"
  >
    <EmailForm />
    <v-app-bar
      class="mobile-menu mobile-header-buttons mobile-header-bar"
      :class="hideMobileHeader ? 'mobile-header-hidden' : ''"
      dark
      app
    >
        <template v-if="showArticleOnly">
          <v-btn
            icon
            depressed
            text
            @click="close"
          >
            <v-icon large>chevron_left</v-icon>
          </v-btn>
          <div
            style="cursor: pointer"
            @click="goBackOrClose"
          >
            <b>
              {{ capitalize($i18n.t('back')) }}
            </b>
          </div>
        </template>
        <div
          v-else
          style="cursor: pointer"
          @click="showLeftMenu = true"
        >
          <b>
            {{ $i18n.t('contact_us') }}
          </b>
        </div>

        <v-spacer />
        <template v-if="!$store.state.showArticleOnly">
          <Flags
            :use-menu="true"
            className="mobile-flags"
          />
        </template>
        <div
          v-if="!showArticleOnly && favorites.length > 0"
          class="justify-end"
        >
          <i
            :class="
              'favorites-btn-mobile mobile-header-btn ' +
              (searchFilters.favorites === 1 ? 'fa fa-heart' : 'far fa-heart')
            "
            @click="goToFavorites"
          />
        </div>

        <template v-if="!showArticleOnly">
          <div
            v-if="!showArticleOnly"
            class="justify-end"
            @click="mobileShare"
          >
            <i class="fa fa-share mobile-header-btn" />
          </div>
          <div
            class="justify-end"
            @click="openFacebook"
          >
            <span class="mdi mdi-facebook-box mobile-header-btn" />
          </div>
          <div
            class="justify-end"
            @click="openInstagram"
          >
            <span class="mdi mdi-instagram mobile-header-btn" />
          </div>
        </template>
        <v-app-bar-nav-icon
          v-if="!showArticleOnly"
          class="no-hover-effect"
          @click="showRightMenu = !showRightMenu"
        />
      </v-app-bar>
      <v-row :style="windowWidth >= windowHeight ? 'margin-top: -48px;' : ''">
        <v-col cols="4"> </v-col>
        <v-col
          cols="4"
          class="mobile-logo"
          style="color: #e3bb22; font-weight: 700"
        >
          <a
            style="cursor: pointer"
            @click="goHomeAndClearSearch"
          >
            <img
              src="../../../../public/img/costa-sol-rent-logo.png"
              alt="Costasolrent.com"
              width="85px"
            />
          </a>
        </v-col>
      </v-row>
    </v-container>
  </v-col>
</template>

<script>
import Flags from './Flags'
import EmailForm from '../../Forms/_EmailForm'
import sharedMethods from '../../../methods/sharedMethods'
import { createHelpers } from 'vuex-map-fields'
import state from '../../../store/state.js'

const { mapFields } = createHelpers({
  getterType: 'getField',
  mutationType: 'updateField',
})

export default {
  name: 'PageHeaderMobile',

  components: {
    EmailForm,
    Flags,
  },

  computed: {
    ...mapFields(Object.keys(state)),

    headerStyle() {
      return {
        height: this.$vuetify.breakpoint.mdAndUp ? '' : '115px', // 110px
      }
    },
  },

  methods: {
    ...sharedMethods,

    goBackOrClose() {
      window.close()
    },

    close() {
      window.close()
    },

    openFacebook() {
      window.open('https://www.facebook.com/costasolrent/', '_blank')
    },

    openInstagram() {
      window.open('https://www.instagram.com/costasolrent.fi/', '_blank')
    },
  },
}
</script>
